import { type ChainflipToken } from '@/shared/assets/tokens';
import { DashboardModal } from '@/shared/components/dashboards/Modal';
import { type AllowedStrategyType } from '@/shared/utils/strategies';
import { SelectAssetModalContent } from '../SelectAssetModalContent';

export default function SelectTokenModal({
  open,
  onTokenSelect,
  onClose,
  onlyStablecoin = false,
  showOnlyAvailableAssets = false,
  strategyType,
}: {
  open: boolean;
  onTokenSelect: (token: ChainflipToken) => void;
  onClose: () => void;
  onlyStablecoin?: boolean;
  showOnlyAvailableAssets?: boolean;
  strategyType?: AllowedStrategyType;
}) {
  return (
    <DashboardModal open={open} onClose={onClose}>
      <SelectAssetModalContent
        onClose={onClose}
        selectToken={onTokenSelect}
        modalHeader="Select Asset"
        onlyStablecoin={onlyStablecoin}
        showOnlyAvailableAssets={showOnlyAvailableAssets}
        strategyType={strategyType}
      />
    </DashboardModal>
  );
}
